<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">{{'enterprise_group_user_management.screen_name' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_group_user_management.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="searchUser(0, paginate.pageSize)">

          <div class="row">

            <div class="col-lg-5 col-md-5 col-sm-12">
              <mat-form-field class="mat-full-width">
                <input type="text" (focusout)="request.name = request.name.trim()" #focusInput matInput
                       [placeholder]="'enterprise_group_user_management.lbl_group_name' | translate" name="name"
                       maxlength="200" [(ngModel)]="request.name" autocomplete="off">
                <button mat-button *ngIf="request.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="request.name=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div class="col-lg-5 col-md-5 col-sm-12">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'enterprise_group_user_management.cbx_status.lbl_status' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus,statusSelect)" id="status" name="status"
                            [(ngModel)]="request.status" (ngModelChange)="searchUser(0, paginate.pageSize)">
                  <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_group_user_management.cbx_status.cbx_status_select_all' | translate}}</mat-option>
                  <mat-option value="true" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_group_user_management.cbx_status.cbx_status_active' | translate}}</mat-option>
                  <mat-option value="false" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'enterprise_group_user_management.cbx_status.cbx_status_inactive' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12 d-flex justify-content-center">
              <div class="w-100 center-vertical">
                <button mat-stroked-button color="primary" type="submit" [disabled]="isTableLoading">
                  <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                  {{'enterprise_group_user_management.buttons.search' | translate}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
          <span>{{'enterprise_group_user_management.list_user_group' | translate}} ({{paginate.totalRow}})</span>
          <button (click)="checkRouter()" class="pull-right" mat-stroked-button color="primary" [disabled]="commonService.getIsLockedEnterprise()">
            <mat-icon class="mr-0">add_circle</mat-icon>{{'enterprise_group_user_management.buttons.add' | translate}}
          </button>
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource">
            <!--STT-->
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_group_user_management.table_headers.no' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = index"
                        class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{paginate.no[dataSource.filteredData.indexOf(element)]}} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!--Tên nhóm-->
            <ng-container matColumnDef="nameGroup">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="width: 25%;">
                {{'enterprise_group_user_management.table_headers.group_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 25%;"
                        matTooltip="{{element.name}}">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 25%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mô tả -->
            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom" style="max-width: 60%">
                {{'enterprise_group_user_management.table_headers.description' | translate}}</mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom"
                        matTooltip="{{element.description}}" style="max-width: 60%">
                <span class="fix-width">{{element.description}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 60%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Ngày tạo -->
            <ng-container matColumnDef="createDate">
              <mat-header-cell *matHeaderCellDef style="max-width: 15%">
                {{'enterprise_group_user_management.table_headers.create_date' | translate}}</mat-header-cell>
              <mat-cell *matCellDef="let element"
                        [matTooltip]="element.createdTime | dateformat"
                        style="max-width: 15%"
                        class="number-cell-center">
                <span class="fix-width">{{element.createdTime | dateformat}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 15%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="status-col mat-cell-non-boder-right-bottom">
                {{'enterprise_group_user_management.table_headers.status' | translate}}</mat-header-cell>
              <!-- [matTooltip]="element.status? ('enterprise_group_user_management.tooltips.icon_status_active' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)
              : ('enterprise_group_user_management.tooltips.icon_status_inactive' | translate) + '&#13;'+ ('enterprise_group_user_management.tooltips.click_change_status' | translate)" -->
              <mat-cell *matCellDef="let element"
                        class="status-col mat-cell-non-boder-right-bottom mat-header-cell-center"
                        matTooltipClass="matTooltipBreakLine"
                        [matTooltip]="(element.status && getPermisionSME)? ('system_document_template.tooltips.icon_status_active' | translate) :
                (!element.status && getPermisionSME)? ('system_document_template.tooltips.icon_status_inactive' | translate) :
                element.status? ('enterprise_group_user_management.tooltips.icon_status_active' | translate) : ('enterprise_group_user_management.tooltips.icon_status_inactive' | translate)">
                <button mat-icon-button (click)="onChangeStatus(element.id,element.name, element.status)" [disabled]="commonService.getIsLockedEnterprise() || getPermisionSME  ">
                  <mat-icon *ngIf="element.status">lock_open</mat-icon>
                  <mat-icon *ngIf="!element.status">lock</mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell status-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tác động -->
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-bottom" style="max-width: 100px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
                        style="max-width: 100px;">
                <button mat-icon-button (click)="openDialogEdit(element.id)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon
                    matTooltip="{{'enterprise_group_user_management.buttons.edit' | translate}}">edit</mat-icon>
                </button>
                <button [routerLink]="['/home-enterprise/autho-user-group', element.id]" mat-icon-button [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon
                    matTooltip="{{'enterprise_group_user_management.buttons.auth' | translate}}">supervisor_account
                  </mat-icon>
                </button>
                <button mat-icon-button *ngIf="!isFromSSO" (click)="delete(element.id,element.name)" [disabled]="commonService.getIsLockedEnterprise()">
                  <i class="fa fa-trash" aria-hidden="true" [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                     matTooltip="{{'button.delete' | translate}}"></i>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 100px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot;
                 an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="searchUser($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
        <!-- /Pagination -->
      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
